import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "../store";
import { HeaderWithSearch } from "../common/Header";
import { PromotionProperties } from "./PromotionProperties";
import { LoginFooter } from "../common/LoginFooter";
import { setLikeProperty } from "../common/Common";

const store = configureStore();

const $ = window.$;

const TemplatePage = () => {
  return <HeaderWithSearch searchBtn={true} hideDesktop={true} />;
};

ReactDOM.render(
  <Provider store={store}>
    <TemplatePage />
  </Provider>,
  document.getElementById("react-app-template")
);

if (document.getElementById("react-app-promotion-property")) {
  ReactDOM.render(
    <Provider store={store}>
      <div className="assets-swiper-container">
        <div className="swiper assets-swiper assets-swiper-1">
          <PromotionProperties />
          <div className="swiper-pagination scroll-pagi assets-pagi-1"></div>
        </div>
        <div
          title="Next"
          className="slick-bt-next swiper-button-next next-btn property-next-1"
        ></div>
        <div
          title="Previous"
          className="slick-bt-back swiper-button-prev prev-btn property-prev-1"
        ></div>
      </div>
    </Provider>,
    document.getElementById("react-app-promotion-property")
  );
}

ReactDOM.render(
  <Provider store={store}>
    <LoginFooter />
  </Provider>,
  document.getElementById("react-app-login-footer")
);

console.log("react app property template start");
